import React from 'react'
import './pending-pay.less'
import SelectPay from '@/pages/payment/common/select-pay/select-pay'
import Checkbox from '@/components/checkbox/checkbox'
import { connect } from 'react-redux'
import * as util from '@/util/util'
import { withRouter } from 'react-router'
import { pendingPayListApi, payBillApi, delBillApi } from '@/api/payment'
import { Toast, SwipeAction, PullToRefresh } from 'antd-mobile'
const APullToRefresh: any = PullToRefresh
const mapStateToProps = (state: any) => {
  return {
    payment: state.payment,
  }
}
@(connect(mapStateToProps) as any)
@(withRouter as any)
class PendingPay extends React.Component<any, any> {
  checkin_id: string = ''
  constructor(props: any) {
    super(props)
    this.state = {
      list: [],
      payType: 'alipay',
      checkedIdList: [],
      totalAmount: 0,
    }
    this.payTypeChange = this.payTypeChange.bind(this)
    this.getBaseInfo = this.getBaseInfo.bind(this)
    this.checkChange = this.checkChange.bind(this)
    this.calculatedTotal = this.calculatedTotal.bind(this)
    this.delBill = this.delBill.bind(this)
    this.goPay = this.goPay.bind(this)
    this.onRefresh = this.onRefresh.bind(this)

    let that = this
    window.paySuccessBack = function() {
      that.props.history.push(`/payment/bill/1`)
    }
  }
  async componentDidMount() {
    const { payment } = this.props
    if (payment.checkin_id) {
      this.setState({ isLoading: true })
      await this.getBaseInfo(payment.checkin_id)
      this.setState({ isLoading: false })
    }
  }
  async componentWillReceiveProps(nextProps: any) {
    const nextInfo = nextProps.payment
    const { payment } = this.props
    this.checkin_id = nextInfo.checkin_id
    if (payment.checkin_id !== nextInfo.checkin_id) {
      //获取待付款列表
      this.getBaseInfo(nextInfo.checkin_id)
    }
  }

  async getBaseInfo(checkin_id: string) {
    Toast.loading('加载中', 0)
    let { data } = await pendingPayListApi(checkin_id)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
    const list = data.data
    let idArray: any = []
    list.forEach((item: any) => {
      idArray.push(item.id)
    })
    this.setState({
      list,
      checkedIdList: idArray,
    })
    this.calculatedTotal(idArray, list)
  }

  //切换支付方式
  payTypeChange(payType: string) {
    this.setState({
      payType: payType,
    })
  }

  async checkChange(checked: boolean, id: string) {
    const { checkedIdList } = this.state
    if (checked) {
      checkedIdList.push(id)
    } else {
      checkedIdList.splice(checkedIdList.indexOf(id), 1)
    }
    await this.setState({
      checkedIdList,
    })

    this.calculatedTotal(checkedIdList, this.state.list)
  }
  async calculatedTotal(checkedIdList: Array<string>, list: Array<any>) {
    let amount: any = 0
    list.forEach((item: any) => {
      if (checkedIdList.indexOf(item.id) !== -1) {
        amount = util.numAdd(amount, item.money)
        //两位小数
        amount = util.toDecimal2(amount)
      }
    })

    this.setState({
      totalAmount: amount,
    })
  }

  //是否选择
  isChecked = (id: string) => {
    return this.state.checkedIdList.indexOf(id) >= 0
  }
  //付款
  async goPay() {
    const { checkedIdList, totalAmount, payType } = this.state
    if (!checkedIdList || checkedIdList.length === 0) {
      Toast.info('请选择缴费项目', 1.5)
      return
    }
    const { payment } = this.props
    const params = {
      bill_ids: checkedIdList,
      checkin_id: payment.checkin_id,
      cost_type: 'recharge',
      money: totalAmount,
      pay_type: payType,
    }

    const { data } = await payBillApi(params)
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1.5)
      return
    }
    let dataString = JSON.stringify(data.data.config)
    if (payType === 'alipay') {
      if (window.WebViewBridge) {
        window.WebViewBridge?.aliPayOld?.call(window.WebViewBridge, dataString)
      } else if (window.webkit) {
        window.webkit.messageHandlers.aliPayOld.postMessage(dataString)
      }
    } else {
      if (window.WebViewBridge) {
        window.WebViewBridge?.weChatPay?.call(window.WebViewBridge, dataString)
      } else if (window.webkit) {
        window.webkit.messageHandlers.weChatPay.postMessage(dataString)
      }
    }
  }
  async delBill(item: any, index: number) {
    Toast.loading('加载中', 0)
    let { data } = await delBillApi({ bill_id: item.id })
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2)
      return
    }
    const { list, checkedIdList } = this.state

    list.splice(index, 1)
    if (checkedIdList.indexOf(item.id) !== -1) {
      checkedIdList.splice(checkedIdList.indexOf(item.id), 1)
    }
    await this.setState({
      checkedIdList,
      list,
    })

    this.calculatedTotal(checkedIdList, list)
  }
  //下拉刷新
  async onRefresh() {
    this.setState({ refreshing: true })
    await this.getBaseInfo(this.checkin_id)
    this.setState({ refreshing: false })
  }
  render() {
    const { list, totalAmount } = this.state
    const listItems = list.map((item: any, index: number) => (
      <SwipeAction
        key={item.id}
        style={{ backgroundColor: 'gray' }}
        autoClose
        right={[
          {
            text: '删除',
            onPress: () => {
              this.delBill(item, index)
            },
            style: { backgroundColor: '#F4333C', color: 'white' },
          },
        ]}
      >
        <div className="p-list-item">
          <div className="p-list-line">
            <label className="p-list-content ">
              <Checkbox
                onChange={(bool: boolean) => {
                  this.checkChange(bool, item.id)
                }}
                checked={this.isChecked(item.id)}
              />
              <div className="name text-ell">{item.subject_name}</div>
              <div className="cycle text-ell">
                {item.type && item.cycle !== '0'
                  ? `${item.cycle}*${item.type}`
                  : '-'}
              </div>
              <div className="amount">{item.money}</div>
            </label>
          </div>
        </div>
      </SwipeAction>
    ))
    return (
      <div className="pending-pay">
        <APullToRefresh
          refreshing={this.state.refreshing}
          onRefresh={this.onRefresh}
          style={{
            height: `calc(100% - 0.5rem)`,
            overflow: 'auto',
          }}
        >
          <div className="p-main">
            <div className="p-list">
              <div className="p-list-item">
                <div className="p-list-line">
                  <div className="p-list-content header">
                    <div className="name">缴费名称</div>
                    <div className="cycle">周期</div>
                    <div className="amount">金额</div>
                  </div>
                </div>
              </div>

              {listItems}
            </div>
            <SelectPay
              style={{ marginTop: '0.1rem' }}
              payType={this.state.payType}
              onChange={this.payTypeChange}
            />
          </div>
        </APullToRefresh>

        <div className="pay">
          <span className="font-5">总计：{totalAmount}元</span>
          <div className="font-4" onClick={() => this.goPay()}>
            付款
          </div>
        </div>
      </div>
    )
  }
}

export default PendingPay
